import useCoupon from './hook';

export default {
  useCoupon,
};
